<template>
    <div class="tutorBox">
        <el-row class="homeContainer1">
            <!--中间-->
            <div class="main clearfix">
                <!--左侧导航-->
                <aside class="nav-left-box">
                    <div class="nav-left">
                        <h5 class="nav-title">文档目录</h5>
                        <el-menu router unique-opened :default-active="$route.path" class="el-menu-vertical-demo">
                            <el-menu-item index="/tutor/ptjj">
                                <span slot="title">平台简介</span>
                            </el-menu-item>
                            <el-submenu index="2">
                                <template slot="title">重要概念</template>
                                <el-menu-item index="/tutor/zygn_jn">技能</el-menu-item>
                                <el-menu-item index="/tutor/zygn_yt">意图</el-menu-item>
                                <el-menu-item index="/tutor/zygn_cw">槽位</el-menu-item>
                                <el-menu-item index="/tutor/zygn_zd">词典</el-menu-item>
                                <el-menu-item index="/tutor/zygn_dldh">多轮对话</el-menu-item>
                            </el-submenu>
                            <el-submenu index="3">
                                <template slot="title">
                                    <span>自定义技能</span>
                                </template>
                                <el-menu-item index="/tutor/zdyjn_ks">快速创建技能</el-menu-item>
                                <el-menu-item index="/tutor/zdyjn_nlupro">NLU语义协议</el-menu-item>
                                <el-menu-item index="/tutor/zdyjn_qqxy">技能请求响应协议</el-menu-item>
                                <!--<el-submenu index="32">-->
                                    <!--<template slot="title">服务协议</template>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzqq">标准请求</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">标准响应</el-menu-item>-->
                                <!--</el-submenu>-->
                            </el-submenu>
                            <el-menu-item index="/tutor/ysnrjn">
                                <span slot="title">内容类技能</span>
                            </el-menu-item>
                            <!--<el-menu-item index="/tutor/znjjjn">-->
                            <!--<span slot="title">智能家居技能 </span>-->
                            <!--</el-menu-item>-->
                            <el-submenu index="10">
                                <template slot="title">
                                    <span>智能家居技能协议</span>
                                </template>
                                <el-menu-item index="/tutor/znjjjnjs">智能家居技能介绍</el-menu-item>
                                <el-menu-item index="/tutor/zn_jnfblc">智能家居技能发布流程</el-menu-item>
                                <el-menu-item index="/tutor/zn_sqlc">智能家居授权流程介绍</el-menu-item>
                                <el-submenu index="33">
                                    <template slot="title">语音OS智能家居协议</template>
                                    <el-menu-item index="/tutor/zn_xygs">协议简介</el-menu-item>
                                    <!--<el-submenu index="34">-->
                                    <!--<template slot="title">协议简介</template>-->
                                    <!--<el-menu-item index="/tutor/zn_xygs">协议概述</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">header参数协议</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">header协议中的namespace列表</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">header协议中name列表</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">payload参数协议</el-menu-item>-->
                                    <!--</el-submenu>-->

                                    <el-submenu index="35">
                                        <template slot="title">设备发现</template>
                                        <el-menu-item index="/tutor/zn_sbfx">设备发现请求</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_dk">单孔插座发现响应</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_duok">多孔插座发现响应</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_wn">万能遥控器发现响应</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_qt">其他品类设备响应返回</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_payload">设备发现payload协议说明</el-menu-item>
                                    </el-submenu>

                                    <el-submenu index="36">
                                        <template slot="title">设备控制</template>
                                        <el-menu-item index="/tutor/zn_sb_dy">电源类的操作</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_pd">频道类的切换</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_sy">声音类的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_bf">播放类的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_ld">亮度的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_wd">温度的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_sd">湿度的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_fs">风速的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_fx">风向的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_ms">模式的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_ys">颜色的设置</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_sw">水位的控制</el-menu-item>
                                        <el-menu-item index="/tutor/zn_sb_xl">吸力的控制</el-menu-item>
                                    </el-submenu>
                                    <el-menu-item index="/tutor/zn_err_message">
                                        <span slot="title">错误响应信息</span>
                                    </el-menu-item>

                                    <!--<el-submenu index="37">-->
                                    <!--<template slot="title">错误响应信息</template>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzqq">错误响应</el-menu-item>-->
                                    <!--<el-menu-item index="/tutor/zdyjn_bzxy">异常响应的信息列表</el-menu-item>-->
                                    <!--</el-submenu>-->
                                    <el-menu-item index="/tutor/zn_appendix">
                                        <span slot="title">附录</span>
                                    </el-menu-item>

                                </el-submenu>
                            </el-submenu>
                            <el-submenu index="6">
                                <template slot="title"> 相关工具</template>
                                <el-menu-item index="/tutor/xggj_tssq">推送申请</el-menu-item>
                                <el-menu-item index="/tutor/xggj_sjgl">数据概览</el-menu-item>
                            </el-submenu>
                            <el-menu-item index="/tutor/jnfb">
                                <span slot="title">技能发布</span>
                            </el-menu-item>
                            <el-submenu index="8">
                                <template slot="title">硬件接入攻略</template>
                                <el-menu-item index="/tutor/yjjrgl">硬件接入攻略</el-menu-item>
                                <el-menu-item index="/tutor/ASDK">Android硬件SDK</el-menu-item>
                                <el-menu-item index="/tutor/license">License</el-menu-item>
                                <el-menu-item index="/tutor/LSDK">linux硬件SDK</el-menu-item>
                                <el-menu-item index="/tutor/FSDK">FreeRTOS硬件SDK</el-menu-item>
                                <!--<el-menu-item index="/tutor/IYYBL">语音伴侣IOS</el-menu-item>-->
                                <!--<el-menu-item index="/tutor/AYYBL">语音伴侣Android</el-menu-item>-->
                                <el-submenu index="55">
                                    <template slot="title">语音伴侣SDK（iOS）</template>
                                    <el-menu-item index="/tutor/env">
                                        <span slot="title"> 环境及组件介绍 </span>
                                    </el-menu-item>
                                    <el-submenu index="55-1">
                                        <template slot="title">OrionServiceSDK接入</template>
                                        <el-menu-item index="/tutor/imp_register">导入及注册</el-menu-item>
                                        <el-menu-item index="/tutor/agreement">实现相关协议</el-menu-item>
                                        <el-menu-item index="/tutor/ios_login">登录</el-menu-item>
                                        <el-menu-item index="/tutor/equipment">设备管理</el-menu-item>
                                        <el-menu-item index="/tutor/info">信息流</el-menu-item>
                                        <el-menu-item index="/tutor/use">OVSMediaCodec使用</el-menu-item>
                                        <el-menu-item index="/tutor/shop">技能商店/闹钟/收藏</el-menu-item>
                                        <el-menu-item index="/tutor/thirdParty">第三方服务</el-menu-item>
                                        <el-menu-item index="/tutor/payment">支付服务</el-menu-item>
                                        <el-menu-item index="/tutor/apns">APNS使用</el-menu-item>
                                    </el-submenu>
                                    <el-menu-item index="/tutor/parameter">
                                        <span slot="title"> 返回参数说明 </span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/errcode">
                                        <span slot="title"> 错误码 </span>
                                    </el-menu-item>
                                </el-submenu>
                                <el-submenu index="56">
                                    <template slot="title">语音伴侣SDK（Android）</template>
                                    <el-menu-item index="/tutor/access">
                                        <span slot="title"> 接入帮助 </span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/info_flow_a">
                                        <span slot="title"> 信息流 </span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/s_list">
                                        <span slot="title"> 技能列表 </span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/s_detail">
                                        <span slot="title"> 技能详情 </span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/x_w">
                                        <span slot="title"> 小微登录接入</span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/payment_a">
                                        <span slot="title"> 支付接入</span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/rev_c">
                                        <span slot="title"> 反向控制</span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/theme">
                                        <span slot="title"> 自定义主题</span>
                                    </el-menu-item>
                                    <el-menu-item index="/tutor/awaken">
                                        <span slot="title"> 唤起码</span>
                                    </el-menu-item>
                                </el-submenu>
                            </el-submenu>
                            <el-menu-item index="/tutor/kfzxy">
                                <span slot="title"> 开发者协议 </span>
                            </el-menu-item>
                            <el-menu-item index="/tutor/faq">
                                <span slot="title"> FAQ </span>
                            </el-menu-item>
                        </el-menu>
                    </div>
                </aside>

                <!--右侧内容区-->
                <section class="content-container">
                    <div class="grid-content bg-purple-light">
                        <el-col :span="24" class="content-wrapper">
                            <transition name="fade" mode="out-in">
                                <router-view></router-view>
                            </transition>
                        </el-col>
                    </div>
                </section>

                <!-- 时间 -->
                <div class="time-wrap"><span>更新时间：2018/03/14</span><span>来源：猎户OS</span></div>
            </div>
        </el-row>

        <span class="go-back" @click="goBack">
        <i class="icon"></i>
        <span class="go-back-tip">返回<br/>顶部</span>
      </span>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                menu: [],
                client_id: ""
            };
        },
        created() {
            //        this.menuList()
            this.getClientId()
        },
        methods: {
            goBack() {
                $('html,body').animate({scrollTop: 0}, 300);
            },
            getClientId() {
                this.client_id = this.$route.query.client_id
            },
            scrollEventTutor() {
                if ($(document).scrollTop() < 500) {
                    $('.go-back').fadeOut();
                } else {
                    $('.go-back').fadeIn();
                }
            }
        }
        //          menuList () {
        //            let menuObj = this.$router.options.routes.filter(item => {
        //              return item.path == '/product'
        //            })
        //            this.menu = menuObj[0].children
        //            console.log(this.menu);
        //          }
    }
</script>
<
<style rel="stylesheet/scss" lang="scss">


    .tutorBox {
        position: relative;
        background: #fff;
        height: 100%;
        .go-back {
            position: fixed;
            left: 50%;
            bottom: 20px;
            line-height: 15px;
            display: none;
            margin-left: 600px;
            width: 40px;
            height: 40px;
            cursor: pointer;
            background: url("../../static/images/hard/go-back.png") no-repeat center;
            .go-back-tip {
                display: none;
                position: absolute;
                padding: 5px 6px;
                border-radius: 5px;
                left: 0;
                top: 0;
                background: #aaa;
                color: #fff;
            }
            &:hover {
                & .go-back-tip {
                    display: block;
                }
            }
        }
        h1,
        h2,
        h3,
        h4,
        h5 {
            padding: 0;
            margin: 0px;
            font-weight: normal;
        }

        ul, li {
            list-style: none;
        }

        .homeContainer1 {
            width: 100%;
            padding-top: 60px;
            min-height: 100%;
            background: #fff;
            .main {
                width: 1030px;
                margin: 0 auto;
                padding: 55px 0 0;
                overflow: hidden;
                position: relative;
            }
            .nav-left-box {

                float: left;
                height: 100%;
                width: 250px;
                min-height: 100%;
                overflow-y: auto;
                background: #f5f5f5;
                .nav-left {
                    width: 100%;
                }
                .nav-title {
                    line-height: 48px;
                    height: 48px;
                    text-align: center;
                    border: 1px solid #f2f2f2;
                    font-size: 16px;
                    color: #1e4d79;
                }

                .el-menu {
                    background: #f5f5f5;
                    border-right: none;
                }
                h5 {
                    line-height: 48px;
                    height: 48px;
                    text-align: center;
                    border: 1px solid #f2f2f2;
                    font-size: 16px;
                }
            }
            .content-container {
                width: 760px;
                min-height: 100%;
                padding-top:10px;
                margin-left: 270px;
                background: #fff;
                overflow: hidden;
            }

            .el-submenu .el-menu-item {
                min-width: 190px;
                background: #f5f5f5;
            }
            .el-menu-item {
                &:hover {
                    background: #ecf5ff;
                }
            }

            .el-submenu {
                min-width: 190px;
                background: #f5f5f5;
            }

        }
        .time-wrap {
            position: absolute;
            top: 65px;
            right: 0px;
            font-size: 12px;
            color: #919191;
            span {
                margin-left: 10px;
            }
        }
        pre {
            border: none;
            background-color: transparent;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/Tutor.vue